import { jsx as _jsx } from "react/jsx-runtime";
import { _className } from '@nu-art/thunderstorm-frontend/index';
import { gif_QuaiLogo } from './assets.js';
const genGif = (asset) => (props) => {
    const { className, ...rest } = props;
    return _jsx("div", { ...rest, className: _className('gif--wrapper', className), children: _jsx("img", { src: asset.path, alt: asset.alt, loading: asset.lazyLoad ? 'lazy' : 'eager' }) });
};
export const GIFS = {
    advisorLogo: genGif(gif_QuaiLogo),
};
//# sourceMappingURL=gifs.js.map